import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../resources/styles.scss';
import { authenticationService } from '../../services/authenticationService.js';
import { createBrowserHistory } from 'history';
import {languages} from '../../utils/localizations.jsx';
import { withTranslation, Trans } from 'react-i18next';
import MediaQuery from 'react-responsive';

export const history = createBrowserHistory();


export class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            language: 'ru',
            isPopupMenuOpen: false
        }
        this.handleSelect = this.handleSelect.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.resetMenu = this.resetMenu.bind(this);
        this.setLanguage = this.setLanguage.bind(this);
    }

    componentDidMount() {
        const language = this.props.i18n.language;
        if (!language) {
            this.setLanguage("ru");
        }
        else if (language.length > 2) {
            let temp = language.substring(0, 2);
            if (languages.indexOf(temp) === -1) {
                this.setLanguage("ru");
            } else {
                this.setLanguage(temp);
            }
        }
        else {
            this.setState({ ...this.state, language: language });
        }
        document.addEventListener('touchend', this.resetMenu);

    }

    componentWillUnmount() {
        document.removeEventListener('touchend', this.resetMenu);
    }

    logout() {
        authenticationService.logout();
        history.push('/login');
    }

    handleSelect(e) {
        this.setLanguage(e.target.value);
    }

    setLanguage(language) {
        this.setState({ ...this.state, language: language });
        this.props.i18n.changeLanguage(language);
    }

    toggleMenu() {
        this.setState({ ...this.state, isPopupMenuOpen: !this.state.isPopupMenuOpen });
    }

    resetMenu(e) {
        if (e.target.matches('.header_menu') || e.target.matches('.menu_popup') || e.target.matches('a')) {
            return;
        }
        this.setState({ ...this.state, isPopupMenuOpen: false });
    }

    renderPages() {
        return (
            <ul>
                <li>
                    <NavLink to="/cards" activeClassName='is-active'><Trans>PagesNames.Cards</Trans></NavLink>
                </li>
                <li>
                    <NavLink to="/operations" activeClassName='is-active'><Trans>PagesNames.Operations</Trans></NavLink>
                </li>
                <li>
                    <NavLink to="/tanks" activeClassName='is-active'><Trans>PagesNames.Tanks</Trans></NavLink>
                </li>
                <li>
                    <a onClick={this.logout}><Trans>Header.LogoutText</Trans></a>
                </li>
            </ul>
        );
    }

    renderLaptopMenu() {
        return (
            <div className="header_menu">
                {this.renderPages()}
            </div>
        );
    }

    renderMobileMenu() {
        return (
            <div className={this.state.isPopupMenuOpen ? "header_menu active" : "header_menu"} onClick={this.toggleMenu} /* onBlur={this.resetMenu} tabIndex={0}*/>
                <div /*onClick={this.toggleMenu} onBlur={this.resetMenu} tabIndex={0}*/>
                </div>
                <div className={this.state.isPopupMenuOpen ? "menu_popup opened" : "menu_popup closed"}>
                    {this.renderPages()}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="app_header">
                <MediaQuery minDeviceWidth={1224}>
                    {this.renderLaptopMenu()}
                </MediaQuery>
                <MediaQuery maxDeviceWidth={1224}>
                    {this.renderMobileMenu()}
                </MediaQuery>
                <select className="language_menu" onChange={this.handleSelect} value={this.state.language}>
                    {languages.map((language, index) =>
                        <option className="select_option" key={index} value={language.key}>{language.value}</option>
                    )}
                </select>
            </div>
        );
    }
};

export default withTranslation('translations')(Header);